<script>
export default {
  name: 'stat-card',
  props: {
    title: {
      type: String,
      default: 'Stat Title'
    },
    icon: {
      type: String,
      default: 'bx bx-error-circle'
    },
    stat: {
      type: [Number, String],
      default: 0
    },
    variant: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    bgVariant () {
      return `bg-soft-${this.variant}`
    },
    textVariant () {
      return `text-${this.variant}`
    }
  }
}
</script>
<template>
  <b-card
    no-body
    v-bind="$attrs"
    v-on="$listeners"
    class="mini-stats-wid icon-grow"
  >
    <b-card-body>
      <div class="d-flex align-items-center">
        <div class="flex-grow-1">
          <h4 class="mb-2">{{ stat }}</h4>
          <p class="text-muted mb-0 fw-medium text-uppercase">{{ title }}</p>
        </div>
        <b-avatar
          :variant="variant"
          class="mini-stat-icon font-size-20"
          size="md"
        >
          <div :class="[icon, 'grow']"></div>
        </b-avatar>
      </div>
    </b-card-body>

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </b-card>
</template>
